import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {retry} from 'rxjs/operators';
import {UrlProviderService} from '../../../shared/services/general';
import {ZipCode} from '../models/common';

@Injectable()
export class AddressService {

  constructor(private urlProvider: UrlProviderService, private httpClient: HttpClient) {
  }

  public getZipCodeByCode(code: string): Observable<ZipCode> {
    return this.httpClient.get<ZipCode>(`${this.urlProvider.ApiUrl}/v2/address/zip-code?code=${code}`)
      .pipe(retry(2));
  }

  public calculateZipCodePlus4(zipCodeId: number, address: string): Observable<string> {
    return this.httpClient.get<string>(`${this.urlProvider.ApiUrl}/v2/address/zip-code/${zipCodeId}/zip-code-extra?address=${address}`)
      .pipe(retry(2));
  }
}
